(function($) {
    $(function() {
        // Button toggler.
        $('button[aria-expanded]').on('click', function() {
            var $button = $(this);
            var $panel = $('#'+$button.attr('aria-controls'));
            
            $button.attr('aria-expanded', function (i, attr) {
                if (attr == 'true') {
                    $button.removeClass('is-active');
                    $panel.slideUp();
                    return 'false';
                } else {
                    $button.addClass('is-active');
                    $panel.slideDown();
                    return 'true';
                }
            });
        });
    });
} )( jQuery );